/**
 * メールアドレスの正規化
 *
 * スマホのフォント装飾（斜体・太字など）で入力されたメールアドレスは、
 * 見た目は英数字でも Unicode の数学用英数字（U+1D400〜）として送られるため、
 * マイページログイン（Firestore の完全一致検索）で一致せずログインできなくなる。
 * NFKC 正規化で数学用英数字・全角英数字・全角記号を半角 ASCII に揃える。
 *
 * 関連: GitHub issue #3302 / Backlog DMO-358
 */
export const normalizeEmail = (email: string): string => {
  return email.normalize("NFKC").trim();
};

/**
 * メールアドレスに使える文字（半角 ASCII の印字可能文字から、単一アドレスとして危険な文字を除く）
 *
 * 除外しているのは `, ; < > : " \ ( ) [ ] @` と空白。
 * nodemailer の addressparser はカンマだけでなく **セミコロンも宛先の区切り**として扱い、
 * `a@b.com<attacker@example.com>` のような山括弧付きは **宛先そのものがすり替わる**ため、
 * 「複数宛先・宛先すり替え」を防ぐにはカンマの除外だけでは不十分（issue #3302）。
 * `@` を文字集合から外すことで `a@b@c.com` のような複数 @ も同時に弾いている。
 *
 * ドット・連続ドット・@直前のドットは許可する（`taro..hanako.@docomo.ne.jp` のような
 * 国内キャリアの旧仕様アドレスを弾かないため）。
 */
const EMAIL_CHAR = "[\\x21\\x23-\\x27\\x2a\\x2b\\x2d-\\x39\\x3d\\x3f\\x41-\\x5a\\x5e-\\x7e]";

/**
 * メールアドレスの入力パターン（半角 ASCII のみ許可、ドメインにドット必須）
 * 正規化しても残る非ASCII文字（ひらがな等）は pattern エラーとする
 * バックエンドの isAsciiEmail（functions/src/modules/normalizeEmail.ts）と同一条件にすること
 */
export const EMAIL_PATTERN = new RegExp(`^${EMAIL_CHAR}+@${EMAIL_CHAR}+\\.${EMAIL_CHAR}+$`);

/**
 * ログイン（既存予約の保存値との照合）用のメールアドレスパターン
 * ドット必須のバックエンドバリデーションは 2025-10-29 導入のため、それ以前の予約には
 * ドメインにドットのないメール（タイポ等）が保存され得る。照合用途では弾かずに通す
 */
export const LOGIN_EMAIL_PATTERN = new RegExp(`^${EMAIL_CHAR}+@${EMAIL_CHAR}+$`);
